

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import User from "@/types/user"
import { Tag } from "@/types"

import apiTag from "@/services/api_Tag"

import StringValidation from "@/scripts/stringValidation"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class TagSetup extends Vue {
	private loading: boolean = false;
	private tags: Tag[] = [];

	private firstLoading: boolean = true;

	public async mounted () {
		await this.loadTags()
	}

	private get columns (): any[] {
		return [ { key: "title", label: "Title", sortable: true, errors: (item: any) => this.checkIfTagIsValid(item) } ]
	}

	private async loadTags () {
		this.loading = true
		this.tags = await apiTag.tagList()
		this.loading = false
	}

	private createTag () {
		return { id: null, title: "" }
	}

	private async saveTag (tag: Tag) {
		await apiTag.tagSave(tag)
		this.loadTags()
	}

	private async deleteTag (tag: Tag) {
		await apiTag.tagDelete(tag)
		this.loadTags()
	}

	private checkIfTagIsValid (item: any): string | null {
		let titleValidationMessage = StringValidation.validateTitle(item.title)
		if (titleValidationMessage != null) {
			return titleValidationMessage
		}

		if (this.firstLoading === false) {
			if (this.tags.some(tag => tag.title.toLocaleLowerCase() === item.title.toLocaleLowerCase())) {
				return "Tag already exists"
			}
		}

		this.firstLoading = false
		return null
	}

	private async rowOpened (item: any) {
		this.firstLoading = true
	}
}
